import { colors, fontFamily } from "../branding/generated/active-tokens";
import { palette } from "../styles/design-tokens";

export const mui = {
  primary: colors.brand.primary,
  primaryContrast: palette["White"],
  secondary: colors.brand.secondary,
  secondaryContrast: palette["Neutral-Darkest"],
  fontBody: fontFamily.body,
};
